module.exports = __webpack_public_path__ + "static/media/L3_4.16a4e857.gif";